import { mobileXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';
import PageWrapper from '../../layout/PageWrapper';
import { Content } from '../../layout/PageWrapper.style';
import { Heading, Text, TextLink } from '../../typography';

export const WhyPrimeContainer = styled(PageWrapper)`
  background-color: ${({ theme }) => theme.backgroundLightest};

  ${Content} {
    max-width: 1240px;
    padding: 0 20px;
  }
`;

export const WhyPrimeWrapper = styled.div`
  margin: 90px auto 115px auto;

  @media (${mobileXLargeMax}) {
    ${Heading} {
      font-size: 25px;
    }
  }
`;

export const WhyPrimeCard = styled.div`
  position: relative;
  border-radius: 8px;
  box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 380px;
  background-color: ${({ theme }) => theme.white};
  padding: 30px;
`;

export const WhyPrimeCardIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 80px;
  margin-bottom: 20px;

  svg {
    height: 100%;
  }
`;

export const WhyPrimeCardTitle = styled(Text)`
  text-align: center;
  font-weight: bold;
  margin: 0 auto 18px auto;
`;

export const WhyPrimeCardList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const WhyPrimeCardListItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 15px;

  svg {
    margin-top: 4px;
    color: ${({ theme }) => theme.prime.GOLD};
  }
`;

export const WhyPrimeCardBox = styled.div`
  width: 100%;
  padding: 12px 22px;
  margin: 15px auto;
  background-color: ${({ theme }) => theme.prime.translucent.GOLD};
  font-size: 14px;
  border-radius: 8px;

  ul {
    margin: 0;
    padding-left: 20px;
    li {
      margin-bottom: 8px;
      &::marker {
        color: ${({ theme }) => theme.prime.GOLD};
      }
    }
  }
`;

export const WhyPrimeLink = styled(TextLink)`
  margin: 50px auto 0 auto;
  text-align: center;
  display: block;
  color: ${({ theme }) => theme.textDark};

  &:hover {
    color: ${({ theme }) => theme.prime.GOLD};
  }
`;
